import { MainLayoutPresenter } from '@client/composition/main-layout/domain/presenter/main-layout.presenter';
import { MainLayoutService } from '@client/composition/main-layout/domain/service/main-layout.service';
import { MainLayoutDependencyTypes } from '@client/composition/main-layout/main-layout.dependency-types';
import { CockpitNavigationService } from '@client/composition/main-layout/domain/service/navigation.service';
import { MainLayoutPiniaStoreAdapter } from '@client/composition/main-layout/application/store/main-layout-pinia.store-adapter';
import type { MainLayoutStoreQuery } from '@client/composition/main-layout/domain/store/main-layout.store-query';
import type { MainLayoutStoreCommand } from '@client/composition/main-layout/domain/store/main-layout.store-command';
import { ContainerModule, type ContainerModuleLoadOptions } from 'inversify';
import { MainLayoutNavigationRefreshService } from '@client/composition/main-layout/domain/service/main-layout-navigation-refresh.service';
import { MainLayoutClientGamesRefreshRequestedListener } from '@client/composition/main-layout/domain/listener/main-layout-client-games-refresh-requested.listener';
import type { ListenerInterface } from '@kiplin/web-common/event';
import { MainLayoutSubscriptionSubscriberProgressService } from '@client/composition/main-layout/domain/service/main-layout-subscription-subscriber-progress.service';
import { MainLayoutGameCreationModalLifecycleListener } from '@client/composition/main-layout/domain/listener/main-layout-game-creation-modal-lifecycle.listener';

export const mainLayoutContainerModule = new ContainerModule((options: ContainerModuleLoadOptions) => {
  options.bind<MainLayoutPresenter>(MainLayoutDependencyTypes.MainLayoutPresenter).to(MainLayoutPresenter);
  options.bind<MainLayoutService>(MainLayoutDependencyTypes.MainLayoutService).to(MainLayoutService);
  options
    .bind<MainLayoutSubscriptionSubscriberProgressService>(
      MainLayoutDependencyTypes.MainLayoutSubscriptionSubscriberProgressService,
    )
    .to(MainLayoutSubscriptionSubscriberProgressService);
  options
    .bind<CockpitNavigationService>(MainLayoutDependencyTypes.CockpitNavigationService)
    .to(CockpitNavigationService);
  options.bind<MainLayoutStoreQuery>(MainLayoutDependencyTypes.MainLayoutStoreQuery).to(MainLayoutPiniaStoreAdapter);
  options
    .bind<MainLayoutStoreCommand>(MainLayoutDependencyTypes.MainLayoutStoreCommand)
    .to(MainLayoutPiniaStoreAdapter);
  options
    .bind<MainLayoutNavigationRefreshService>(MainLayoutDependencyTypes.MainLayoutNavigationRefreshService)
    .to(MainLayoutNavigationRefreshService);
  options
    .bind<ListenerInterface>(MainLayoutDependencyTypes.MainLayoutClientGamesRefreshRequestedListener)
    .to(MainLayoutClientGamesRefreshRequestedListener)
    .inSingletonScope();
  options
    .bind<ListenerInterface>(MainLayoutDependencyTypes.MainLayoutGameCreationModalLifecycleListener)
    .to(MainLayoutGameCreationModalLifecycleListener)
    .inSingletonScope();
});
